<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="title" placeholder="请输入内容" size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="search">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="hospital_name" label="医院名称"> </el-table-column>
                <el-table-column prop="hospital_describe" label="医院描述" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="hospital_grade_text" label=" 医院等级" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="hospital_contact_number" label="医院联系电话"> </el-table-column>
                <el-table-column prop="province_code_text" label="所在省份"> </el-table-column>
                <el-table-column prop="city_code_text" label="所在城市"> </el-table-column>
                <el-table-column prop="area_code_text" label="所在区域"> </el-table-column>
                <el-table-column prop="hospital_address" label="详细地址"> </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  -->
        <el-dialog title="医院设置" :visible.sync="dialogs" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="医院名称:">
                        <el-input size="small" v-model="form.hos_name"></el-input>
                    </el-form-item>
                    <el-form-item label="医院电话" prop="CityName">
                        <el-input size="small" v-model="form.hos_tel"></el-input>
                    </el-form-item>
                    <el-form-item label="医院地址" required>
                        <div class="u-f ">
                            <el-form-item prop="sf_id" style="margin-right:10px">
                                <el-select v-model="form.sf_id" placeholder="请选择" size="small" @change="getsq">
                                    <el-option v-for="item in sf_options" :key="item.code" :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="sq_id" style="margin-right:10px">
                                <el-select v-model="form.sq_id" placeholder="请选择" size="small" clearable
                                    @change="getqy">
                                    <el-option v-for="item in sq_options" :key="item.code" :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="qy_id" style="margin-right:10px">
                                <el-select v-model="form.qy_id" placeholder="请选择" size="small" clearable>
                                    <el-option v-for="item in qy_options" :key="item.code" :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <el-form-item label="医院详细地址" prop="hos_xqxx">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.hos_xqxx"
                            style="width:80%">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="医院级别" prop="CityName">
                        <el-select v-model="form.hos_dj" placeholder="请选择" size="small" clearable>
                            <el-option v-for="item in dj_options" :key="item.id" :label="item.content_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="医院描述" prop="hos_ms">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.hos_ms" style="width:80%">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('form')" size="small">确 定</el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                dialog: false,
                title: '',
                loading: false,
                tableData: [],
                heights: null,

                // 
                eid: '',
                sf_options: [],
                sq_options: [],
                qy_options: [],
                dj_options:[],
                dialogs: false,
                form: {
                    hos_name: '',
                    hos_ms: '',
                    sf_id: '',
                    sq_id: '',
                    qy_id: '',
                    hos_xqxx: '',
                    hos_dj: '',
                    hos_tel: '',
                },
                rule: {
                   
                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getsf()
            that.getdj()
            that.getHeight()
            that.search()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 150 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 150 + 'px'
                }
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/HospitalList", {
                        
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                    })
                    .catch(error => {})
            },
            // 新增
            add() {
                let that = this
                that.dialogs = true
                that.eid = '0'
                that.clear()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls
                        if (that.eid && that.eid != '0') {
                             urls = "/admin/HospitalEdit"
                        } else {
                            urls = "/admin/HospitalAdd"
                        }
                        axios
                            .post(urls, {
                                id: that.eid,
                                hospital_name: that.form.hos_name,
                                hospital_describe: that.form.hos_ms,
                                province_code: that.form.sf_id,
                                city_code: that.form.sq_id,
                                area_code: that.form.qy_id,
                                hospital_address: that.form.hos_xqxx,
                                hospital_grade: that.form.hos_dj,
                                hospital_contact_number: that.form.hos_tel,
                                author: that.user.id
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.message);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                axios
                    .post("/admin/HospitalEditInfo", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        if (data) {
                            that.form.hos_name = data.hospital_name
                            that.form.hos_ms = data.hospital_describe
                            that.form.sf_id = data.province_code ? data.province_code.toString() : ''
                            that.getsq()
                            that.form.sq_id = data.city_code ? data.city_code.toString() : ''
                            that.getqy()
                            that.form.qy_id = data.area_code ? data.area_code.toString() : ''
                            that.form.hos_xqxx = data.hospital_address
                            that.form.hos_dj = data.hospital_grade
                            that.form.hos_tel = data.hospital_contact_number
                        } else {
                            that.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/HospitalDel", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this
                that.form.hos_name = ''
                that.form.hos_ms = ''
                that.form.sf_id = ''
                that.form.sq_id = ''
                that.form.qy_id = ''
                that.form.hos_xqxx = ''
                that.form.hos_dj = ''
                that.form.hos_tel = ''
            },
            // 获取省份
            getsf() {
                let that = this
                axios
                    .post("/admin/Area/getProvince_vue", {}, {
                        token: true
                    })
                    .then(response => {
                        that.sf_options = response.data.data
                    })
                    .catch(error => {})
            },
            getsq() {
                let that = this
                that.sq_options = []
                that.form.sq_id = ''
                that.qy_options = []
                that.form.qy_id = ''
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.form.sf_id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.sq_options = response.data.data
                    })
                    .catch(error => {})
            },
            getqy() {
                let that = this
                that.qy_options = []
                that.form.qy_id = ''
                axios
                    .post("/admin/Area/getChild_vue", {
                        parentcode: that.form.sq_id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.qy_options = response.data.data
                    })
                    .catch(error => {})
            },
            getdj(){
                let that = this
                axios
                    .post("/admin/getContentBySysTypeId", {
                        sys_id: 1,  
                        type_id:5
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.dj_options = response.data.data
                    })
                    .catch(error => {})
            },
        },

    };
</script>